import { Action } from "@ngrx/store";
import { AnalyzedToken } from "src/app/shared/models/analyzed-token.model";
import { EntryRequest } from "../interfaces/entry-request.model";
import { Entry } from "../interfaces/entry.model";
import { LexicalEntry } from "../interfaces/lexical-entry.model";
import { QueryForm } from "../interfaces/query-form.model";
import { ReduceResource } from "../interfaces/reduce-resource.model";
import { SearchTokenReq } from "../interfaces/search-token-req.model";
import { SearchTokenResp } from "../interfaces/search-token-resp.model";
import { SearchTokens } from "../interfaces/search-tokens.model";
import { SemanticGroupTextualForms } from "../interfaces/semantic-group-textual-forms.model";

/**Interfaccia per il tipo di dato POS */
export interface POS {
    /**Etichetta della POS */
    label: string;
    /**Conteggio delle entrate per la POS data */
    // count: number;
}

/**Descrizione per il tipo SetQueryForm */
export const SET_QUERY_FORM = '[SEARCH] Azione di inserimento parametri per la ricerca';

/**Descrizione per il tipo SetSelectedResources */
export const SET_SELECTED_RESOURCES = '[SEARCH] Azione di selezione delle risorse sulle quali effettuare la ricerca';

/**Descrizione per il tipo StartGetResourceTree */
export const START_GET_RESOURCE_TREE = '[SEARCH] Azione di inizio recupero albero risorse senza unità logiche';
/**Descrizione per il tipo GetResourceTreeSuccess */
export const GET_RESOURCE_TREE_SUCCESS = '[SEARCH] Avvenuto recupero albero risorse senza unità logiche';
/**Descrizione per il tipo GetResourceTreeFailure */
export const GET_RESOURCE_TREE_FAILURE = '[SEARCH] Mancato recupero albero risorse senza unità logiche';

/**Descrizione per il tipo StartGetPosList */
export const START_GET_POS_LIST = '[SEARCH] Azione di inizio recupero lista delle POS';
/**Descrizione per il tipo GetPosListSuccess */
export const GET_POS_LIST_SUCCESS = '[SEARCH] Avvenuto recupero lista delle POS';
/**Descrizione per il tipo GetPosListFailure */
export const GET_POS_LIST_FAILURE = '[SEARCH] Mancato recupero lista delle POS';

/**Descrizione per il tipo StartGetLexicalSenses */
export const START_GET_LEXICAL_SENSES = '[SEARCH] Azione di inizio recupero sensi lessicali';
/**Descrizione per il tipo GetLexicalSensesSuccess */
export const GET_LEXICAL_SENSES_SUCCESS = '[SEARCH] Avvenuto recupero sensi lessicali';
/**Descrizione per il tipo GetLexicalSensesFailure */
export const GET_LEXICAL_SENSES_FAILURE = '[SEARCH] Mancato recupero sensi lessicali';

export const START_GET_FORMS_LIST = '[SEARCH] Azione di inizio recupero elenco di forme';
export const GET_FORMS_LIST_SUCCESS = '[SEARCH] Avvenuto recupero elenco di forme';
export const GET_FORMS_LIST_FAILURE = '[SEARCH] Mancato recupero elenco di forme';

export const START_GET_ID_FORMS_LIST = '[SEARCH] Azione di inizio recupero elenco di forme per un id';
export const GET_ID_FORMS_LIST_SUCCESS = '[SEARCH] Avvenuto recupero elenco di forme per un id';
export const GET_ID_FORMS_LIST_FAILURE = '[SEARCH] Mancato recupero elenco di forme per un id';

export const LEX_ENTRY_MODAL_VISIBILITY = '[SEARCH] Gestione visualizzazione modale lexical entry';

export const START_CREATE_LEXICAL_ENTRY = '[SEARCH] Azione di inizio creazione di una nuova entrata lessicale';
export const CREATE_LEXICAL_ENTRY_SUCCESS = '[SEARCH] Avvenuta creazione di una nuova entrata lessicale';
export const CREATE_LEXICAL_ENTRY_FAILURE = '[SEARCH] Mancata creazione di una nuova entrata lessicale';

export const MORPH_TRAIT_MODAL_VISIBILITY = '[SEARCH] Gestione visualizzazione modale tratti morfologici';

export const SAVE_MORPH_TRAIT = '[SEARCH] Azione di salvataggio dei tratti morfologici';

export const START_GET_OCCURRENCE_FROM_RESOURCE = '[SEARCH] Azione di inizio recupero delle occorrenze nelle risorse';
export const GET_OCCURRENCE_FROM_RESOURCE_SUCCESS = '[SEARCH] Avvenuto recupero delle occorrenze nelle risorse';
export const GET_OCCURRENCE_FROM_RESOURCE_FAILURE = '[SEARCH] Mancato recupero delle occorrenze nelle risorse';

export const START_GET_DESCRIPTION_SENSE = '[SEARCH] Azione di inizio recupero delle descrizioni del senso target per un elenco di semantic group';
export const GET_DESCRIPTION_SENSE_SUCCESS = '[SEARCH] Avvenuto recupero delle descrizioni del senso target per un elenco di semantic group';
export const GET_DESCRIPTION_SENSE_FAILURE = '[SEARCH] Mancato recupero delle descrizioni del senso target per un elenco di semantic group';

export const START_GET_SENSES_BY_CONCEPT = '[SEARCH] Azione di inizio recupero dei sensi relativi a un template';
export const GET_SENSES_BY_CONCEPT_SUCCESS = '[SEARCH] Avvenuto recupero dei sensi relativi a un template';
export const GET_SENSES_BY_CONCEPT_FAILURE = '[SEARCH] Mancato recupero dei sensi relativi a un template';

export const START_GET_SENSES_BY_CONCEPT_2 = '[SEARCH] Azione di inizio recupero dei sensi relativi a un template o tratto';
export const GET_SENSES_BY_CONCEPT_2_SUCCESS = '[SEARCH] Avvenuto recupero dei sensi relativi a un template o tratto';
export const GET_SENSES_BY_CONCEPT_2_FAILURE = '[SEARCH] Mancato recupero dei sensi relativi a un template o tratto';

export const START_GET_ID_FORMS_LIST_FROM_TEMPLATE = '[SEARCH] Azione di inizio recupero delle forme di un id da template';
export const CANCEL_GET_ID_FORMS_LIST_FROM_TEMPLATE = '[SEARCH] Azione di cancellazione recupero delle forme di un id da template';
export const GET_ID_FORMS_LIST_FROM_TEMPLATE_PARTIAL = '[SEARCH] Avvenuto recupero primo blocco';

export const START_GET_ANALYZED_SENTENCE = '[SEARCH] Inizio azione di recupero del pos tagging di un frammento';
export const GET_ANALYZED_SENTENCE_SUCCESS = '[SEARCH] Avvenuta azione di recupero del pos tagging di un frammento';
export const GET_ANALYZED_SENTENCE_FAILURE = '[SEARCH] Mancata azione di recupero del pos tagging di un frammento';

export const SET_SELECTED_SENSES_BY_CONCEPT = '[SEARCH] Azione di memorizzazione dei termini da template selezionati';

export const CLEAN_LEXICAL_SENSES = '[SEARCH] Azione di svuotamento dei sensi lessicali';

/**Descrizione per il tipo CleanOnExit */
export const CLEAN_ON_EXIT = '[SEARCH] Azione di pulizia dello stato in uscita da ricerca avanzata';

/**Azione di inserimento parametri per la ricerca */
export class SetQueryForm implements Action {
    readonly type = SET_QUERY_FORM;

    /**
     * Costruttore per l'azione di impostazione dei parametri di ricerca
     * @param payload {QueryForm} parametri di ricerca
     */
    constructor(public payload: QueryForm) { }
}

/**Azione di selezione delle risorse sulle quali effettuare la ricerca */
export class SetSelectedResources implements Action {
    readonly type = SET_SELECTED_RESOURCES;
    /**
     * Costruttore per l'azione di selezione delle risorse
     * @param payload {number[]} elenco degli identificativi di risorsa selezionati
     */
    constructor(public payload: number[]) { }
}

/**Azione di recupero albero delle risorse senza unità logiche */
export class StartGetResourceTree implements Action {
    readonly type = START_GET_RESOURCE_TREE;
}

/**Azione di recupero albero delle risorse senza unità logiche */
export class GetResourceTreeSuccess implements Action {
    readonly type = GET_RESOURCE_TREE_SUCCESS;

    constructor(public payload: ReduceResource) { }
}

/**Azione di recupero albero delle risorse senza unità logiche */
export class GetResourceTreeFailure implements Action {
    readonly type = GET_RESOURCE_TREE_FAILURE;
}

export class StartGetPosList implements Action {
    readonly type = START_GET_POS_LIST;
}
export class GetPosListSuccess implements Action {
    readonly type = GET_POS_LIST_SUCCESS;

    constructor(public payload: POS[]) { }
}
export class GetPosListFailure implements Action {
    readonly type = GET_POS_LIST_FAILURE;
}

export class StartGetLexicalSenses implements Action {
    readonly type = START_GET_LEXICAL_SENSES;

    constructor(public payload: EntryRequest) { }
}
export class GetLexicalSensesSuccess implements Action {
    readonly type = GET_LEXICAL_SENSES_SUCCESS;

    constructor(public payload: Entry[]) { }
}
export class GetLexicalSensesFailure implements Action {
    readonly type = GET_LEXICAL_SENSES_FAILURE;
}

export class StartGetFormsList implements Action {
    readonly type = START_GET_FORMS_LIST;

    constructor(public payload: {
        searchT:SearchTokens[], 
        resources: number[], 
        toRow: number, 
        morphTraits: {mus: string, morph: any}[],
        queryFormType: string, 
        queryFormName: string, 
        lexicalSenses: Entry[]
    }, public isFromTemplate = false) { }
}
export class GetFormsListSuccess implements Action {
    readonly type = GET_FORMS_LIST_SUCCESS;

    constructor(public payload: {response: SemanticGroupTextualForms[], resources: number[], toRow: number}, public isFromTemplate = false) { }
}
export class GetFormsListFailure implements Action {
    readonly type = GET_FORMS_LIST_FAILURE;
}

export class StartGetIdFormsList implements Action {
    readonly type = START_GET_ID_FORMS_LIST;

    constructor(public payload: {
        mus: string[], 
        resources: number[], 
        toRow: number,
        morphTraits: {mus: string, morph: any}[],
        queryFormType: string, 
        queryFormName: string, 
        lexicalSenses: Entry[]
    }, public isFromTemplate = false) { }
}
export class GetIdFormsListSuccess implements Action {
    readonly type = GET_ID_FORMS_LIST_SUCCESS;

    constructor(public payload: {
        response: SemanticGroupTextualForms[], 
        resources: number[], 
        toRow: number
    }, public isFromTemplate = false) { }
}
export class GetIdFormsListFailure implements Action {
    readonly type = GET_ID_FORMS_LIST_FAILURE;
}

export class StartGetIdFormsListFromTemplate implements Action {
    readonly type = START_GET_ID_FORMS_LIST_FROM_TEMPLATE;
    constructor(public payload: { accumulatore: SemanticGroupTextualForms[], idList: string[], resources: number[], toRow: number }, public isFromTemplate = true) { }
}

export class CancelGetIdFormsListFromTemplate implements Action {
    readonly type = CANCEL_GET_ID_FORMS_LIST_FROM_TEMPLATE;
}

export class GetIdFormsListFromTemplatePartial implements Action {
    readonly type = GET_ID_FORMS_LIST_FROM_TEMPLATE_PARTIAL;
    constructor(public payload: { accumulatore: SemanticGroupTextualForms[], idList: string[], resources: number[], toRow: number }, public isFromTemplate = true) { }
}

export class LexEntryModalVisibility implements Action {
    readonly type = LEX_ENTRY_MODAL_VISIBILITY;

    constructor(public payload: boolean) { }
}

export class StartCreateLexicalEntry implements Action {
    readonly type = START_CREATE_LEXICAL_ENTRY;
}
export class CreateLexicalEntrySuccess implements Action {
    readonly type = CREATE_LEXICAL_ENTRY_SUCCESS;

    constructor(public payload: LexicalEntry) { }
}
export class CreateLexicalEntryFailure implements Action {
    readonly type = CREATE_LEXICAL_ENTRY_FAILURE;
}

export class MorphTraitModalVisibility implements Action {
    readonly type = MORPH_TRAIT_MODAL_VISIBILITY;
    constructor(public payload: { visible: boolean, pos: string, mus: string }) { }
}

export class SaveMorphTrait implements Action {
    readonly type = SAVE_MORPH_TRAIT;

    constructor(public payload: { mus: string, morph: any }) { }
}

export class StartGetOccurrenceFromResource implements Action {
    readonly type = START_GET_OCCURRENCE_FROM_RESOURCE;

    constructor(public payload: SearchTokenReq) { }
}
export class GetOccurrenceFromResourceSuccess implements Action {
    readonly type = GET_OCCURRENCE_FROM_RESOURCE_SUCCESS;

    constructor(public payload: SearchTokenResp) { }
}
export class GetOccurrenceFromResourceFailure implements Action {
    readonly type = GET_OCCURRENCE_FROM_RESOURCE_FAILURE;
}

export class StartGetDescriptionSense implements Action {
    readonly type = START_GET_DESCRIPTION_SENSE;

    constructor(public payload: {semanticG: SemanticGroupTextualForms[], resources: number[], toRow: number}) { }
}
export class GetDescriptionSenseSuccess implements Action {
    readonly type = GET_DESCRIPTION_SENSE_SUCCESS;

    constructor(public payload: {response:SemanticGroupTextualForms[], resources: number[], toRow: number}) { }
}
export class GetDescriptionSenseFailure implements Action {
    readonly type = GET_DESCRIPTION_SENSE_FAILURE;
}

export class StartGetSensesByConcept implements Action {
    readonly type = START_GET_SENSES_BY_CONCEPT;

    constructor(public payload: string[]) { }
}
export class GetSensesByConceptSuccess implements Action {
    readonly type = GET_SENSES_BY_CONCEPT_SUCCESS;

    constructor(public payload: Entry[]) { }
}
export class GetSensesByConceptFailure implements Action {
    readonly type = GET_SENSES_BY_CONCEPT_FAILURE;
}
export class StartGetSensesByConcept2 implements Action {
    readonly type = START_GET_SENSES_BY_CONCEPT_2;

    constructor(public payload: { templateList: string[], traitList: string[]}) { }
}
export class GetSensesByConceptSuccess2 implements Action {
    readonly type = GET_SENSES_BY_CONCEPT_2_SUCCESS;

    constructor(public payload: Entry[]) { }
}
export class GetSensesByConceptFailure2 implements Action {
    readonly type = GET_SENSES_BY_CONCEPT_2_FAILURE;
}

export class StartGetAnalyzedSentence implements Action {
    readonly type = START_GET_ANALYZED_SENTENCE;

    constructor(public payload: number) {}
}
export class GetAnalyzedSentenceSuccess implements Action {
    readonly type = GET_ANALYZED_SENTENCE_SUCCESS;

    constructor(public payload: AnalyzedToken[]) {}
}
export class GetAnalyzedSentenceFailure implements Action {
    readonly type = GET_ANALYZED_SENTENCE_FAILURE;
}

export class SetSelectedSensesByConcept implements Action {
    readonly type = SET_SELECTED_SENSES_BY_CONCEPT;
    constructor(public payload: string[]) { }
}

export class CleanLexicalSenses implements Action {
    readonly type = CLEAN_LEXICAL_SENSES;
}

export class CleanOnExit implements Action {
    readonly type = CLEAN_ON_EXIT;
}

/**Tipi di azioni disponibili per la sezione ricerca dello stato */
export type RicercaAction =
    | SetQueryForm
    | SetSelectedResources
    | StartGetResourceTree
    | GetResourceTreeSuccess
    | GetResourceTreeFailure
    | StartGetPosList
    | GetPosListSuccess
    | GetPosListFailure
    | StartGetLexicalSenses
    | GetLexicalSensesSuccess
    | GetLexicalSensesFailure
    | StartGetFormsList
    | GetFormsListSuccess
    | GetFormsListFailure
    | StartGetIdFormsList
    | GetIdFormsListSuccess
    | GetIdFormsListFailure
    | StartGetIdFormsListFromTemplate
    | CancelGetIdFormsListFromTemplate
    | GetIdFormsListFromTemplatePartial
    | LexEntryModalVisibility
    | StartCreateLexicalEntry
    | CreateLexicalEntrySuccess
    | CreateLexicalEntryFailure
    | MorphTraitModalVisibility
    | SaveMorphTrait
    | StartGetOccurrenceFromResource
    | GetOccurrenceFromResourceSuccess
    | GetOccurrenceFromResourceFailure
    | StartGetDescriptionSense
    | GetDescriptionSenseSuccess
    | GetDescriptionSenseFailure
    | StartGetSensesByConcept
    | GetSensesByConceptSuccess
    | GetSensesByConceptFailure
    | StartGetSensesByConcept2
    | GetSensesByConceptSuccess2
    | GetSensesByConceptFailure2
    | StartGetAnalyzedSentence
    | GetAnalyzedSentenceSuccess
    | GetAnalyzedSentenceFailure
    | SetSelectedSensesByConcept
    | CleanLexicalSenses
    | CleanOnExit;